'use strict';

module.exports = function count() {
  if (Array.isArray(this.items)) {
    return this.items.length;
  }

  return Object.keys(this.items).length;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/methods/count.js
// module id = 563
// module chunks = 0